// Filtro "Tipo" da tela de contratos.
// Os valores precisam bater com App\Constants\ContractTypeFilterTypes do backend-core,
// que é quem resolve cada tipo para as soluções financeiras correspondentes.

export const EP = 'ep'
export const SUBSCRIPTION = 'subscription'

export const CONTRACT_TYPES = [
  { key: EP, name: 'EP' },
  { key: SUBSCRIPTION, name: 'Assinatura' },
]
